import React from 'react';

const FallbackWidget: React.FC = () => {
  return (
    <div className="flex items-center justify-center p-8">
      <div className="text-center">
        <p className="text-gray-600 text-base">
          Failed to load content. Please retry.
        </p>
      </div>
    </div>
  );
};

export default FallbackWidget;
